import { RecentlyViewedProducts } from "~/features/RecentlyViewedProducts/RecentlyViewedProducts";
import type ComponentTypes from "~/features/cms/componentTypes";

/**
 * CMS wrapper for the OOTB SAP YMKT {@code CMSSAPRecommendationComponent}.
 *
 * <p>The BFF transformer ({@code CMSSAPRecommendationComponentTransformer}) emits only the component
 * configuration (title, recotype, includerecent, …) — the actual recommended products are fetched
 * client-side by {@link RecentlyViewedProducts} (the same React island the legacy
 * {@code cmssaprecommendationcomponent.jsp} mounted via {@code createComponentAtId}). The config blob
 * is therefore intentionally ignored here; the island owns its data and rendering, mirroring the
 * pre-shell JSP behavior where the component mounted with no server props.
 */
export interface CMSSAPRecommendationProps {
  type: ComponentTypes.CMSSAPRecommendation;
  id?: string;
  className?: string;
  title?: string;
  recotype?: string;
  leadingitemtype?: string;
  leadingitemdstype?: string;
  cartitemdstype?: string;
  includecart?: boolean;
  includerecent?: boolean;
}

export const CMSSAPRecommendation = (_props: CMSSAPRecommendationProps) => {
  return <RecentlyViewedProducts variant="default" />;
};
